module.exports = __webpack_public_path__ + "static/media/NUserManagement.199f37dd.png";